import React from "react";
import { Container, Row, Col, Button } from "react-bootstrap";
import "../ComponentsCSS/SpecialCare.css";
import { Link } from "react-router-dom";

const TransportationServices = () => {
  const services = [
    {
      title: "Special Needs Transformation",
      description:
        "All sorts of wheelchairs. Broda chair. electric and manual chair delivery and transportation",
      icon: "🦽",
    },
    {
      title: "Medical Equipments",
      description:
        "All medical supplies and equipments such as oxygen tank and sensitive drugs",
      icon: "📦",
    },
    {
  title: "Airport / Courier Services",
  description:
    "We can provide full ground transportation for any and all of your needs, including special events.",
  icon: "✈️",
}
  ];

  return (
    <section className="transportation-services">
      <Container>
        <div className="section-header" data-aos="zoom-in">
          <h2 className="section-title">
            Let Us Get You Transferred with Special Care
          </h2>
          <p className="section-subtitle">
            24 hours Services with the possibility of having a Charge Account
          </p>
        </div>

        <Row className="justify-content-center position-relative line-wrap">
          {services.map((service, index) => (
            <Col key={index} xs={12} md={6} lg={4} className="d-flex">
              <div
                className="service-card w-100 position-relative"
                data-aos="flip-right"
              >
                <div className="service-icon">{service.icon}</div>
                <h3 className="service-title">{service.title}</h3>
                <p className="service-description">{service.description}</p>
              </div>
            </Col>
          ))}
        </Row>

        <div className="text-center mt-5" data-aos="zoom-in">
          <Link to="/services">
            <Button className="see-all-btn">See All Services</Button>
          </Link>
        </div>
      </Container>
    </section>
  );
};

export default TransportationServices;
